import React from "react";
import { ListGroup, Accordion } from "react-bootstrap";
import moment from "moment";
import { EmailHistory } from "../../models/responses/emailHistory";

interface EmailHistoryAccordionProps {
    emailHistory: EmailHistory[] | null;
}

const EmailHistoryAccordion: React.FC<EmailHistoryAccordionProps> = ({ emailHistory }) => (
    <Accordion>
        <Accordion.Item eventKey="0">
            <Accordion.Header>
                Skickad e-post
            </Accordion.Header>
            <Accordion.Body>
                <ListGroup as="ul">
                    {emailHistory?.map((email, idx) => {
                        let subject = "";
                        let body = "";
                        try {
                            const content = JSON.parse(email.emailContent);
                            subject = content.Subject || "";
                            body = content.Body || "";
                        } catch (e) {
                            subject = email.emailContent;
                            body = "";
                        }
                        // Ta bort HTML-taggar
                        const plainBody = body.replace(/<[^>]+>/g, "");
                        return (
                            <ListGroup.Item as="li" key={idx}>
                                <div>
                                    <strong>Ämne:</strong> {subject}
                                </div>
                                <div>
                                    <strong>Meddelande:</strong>
                                    <div style={{marginTop: 4}}>{plainBody}</div>
                                </div>
                                <div>
                                    <strong>Mottagare:</strong> {email.recipientEmail}
                                </div>
                                <div>
                                    <strong>Avsändare:</strong> {email.senderEmail}
                                </div>
                                <div>
                                    <strong>Inloggad användare:</strong> {email.userName}
                                </div>
                                <div>
                                    <strong>Datum:</strong> {email.sentAt ? moment.utc(email.sentAt).local().format("YYYY-MM-DD HH:mm") : "-"}
                                </div>
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>
);

export default EmailHistoryAccordion;
